module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAARCAYAAADtyJ2fAAAAAXNSR0IArs4c6QAAAWFJREFUKBWdUjGqwkAQfSYxprAL2JkmtWCwzRVE8AwptAh4AoucQIKIhZeQHECLIFioJ7AxnWhnYUTNzyxkSdYgH1+z+2bm7ey83UqSAj9AyWtOpxPm8znq9ToP3243DAYDGIbBY2xDHTN4npc8Ho+MspU4xUVI+WPSJKrVaj7EOMVFFIRi8hv/WcjMWSwWuN/v3xpgOp1C0zQ4jsPqWMfNZoPtdos4jkvFFKc81WWokFtEUufQ6/UQBAGOxyPO5zMajQZM00S328VyucR4PM504ELXdZFaj2azidfrhff7DUmSIMsyoihCrVaD7/ufwufziclkwmalj3C9XqHrOnt4mm00GkFRcv+Fripiv98n/X4/ORwOYorz0uewLAutVgvtdptfTdyUCqmI5vsGbg4V7XY75p6qqgjDELZtM8PI7U6nUzgnNy2wWq1wuVwwm8140XA4xHq9/hAWOvLqf2z+ANTW7Oy/orqAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/oficina.png
// module id = 513
// module chunks = 0